import React from 'react';
import UserManagement from '../components/UserManagement';

const UserManagementPage: React.FC = () => {
  return <UserManagement />;
};

export default UserManagementPage;